// GENERATED CODE - DO NOT EDIT
export const CheckoutFlowTypeMap = {
    PROGYNY_WIZARD: 'progyny_wizard',
    EARLIEST_DATE_COMPOUND: 'earliest_date_compound',
    NEEDLE_PROMPT: 'needle_prompt',
    NEEDLE_PROMPT_NO_NEEDLES: 'needle_prompt_no_needles',
    DOSE_CHANGE: 'dose_change',
    MULTIPLE_ACTIVE_RX: 'multiple_active_rx',
    MOUNJARO_DOSE: 'mounjaro_dose',
    DIABETES_ELECTION: 'diabetes_election',
    AUTO_REFILL_ELIGIBLE: 'auto_refill_eligible',
    PHOTO_ID_UPLOAD: 'photo_id_upload',
    ADD_TO_SHIPMENT: 'add_to_shipment',
    ANCILLARY: 'ancillary',
    COMPOUNDED: 'compounded',
};
//# sourceMappingURL=checkout_flow_type.js.map